import { render, staticRenderFns } from "./How.vue?vue&type=template&id=9c391130&scoped=true&"
import script from "./How.vue?vue&type=script&lang=js&"
export * from "./How.vue?vue&type=script&lang=js&"
import style0 from "./How.vue?vue&type=style&index=0&id=9c391130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c391130",
  null
  
)

export default component.exports